import React, { useEffect, useState } from 'react';
import {
  Stack,
  Typography,
  Divider,
  Box,
  Link as MuiLink,
} from '@mui/material';
import { Link } from 'react-router-dom';

// COMPONENTS
import CardWrapper from '../CardWrapper';
import Loader from '../../common/Loader';

// MESSAGES
import HomeFormattedMessages from '../../../messages/HomeFormattedMessages';

// REQUESTS
import useDashboardRequest from '../../../requests/DashboardRequest';

export default function MessageBalance({
  messageOnly,
  creditsOnly,
  errorHandler,
}) {
  const [balances, setBalances] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getMessageBalance } = useDashboardRequest();
  const linkStyles = {
    fontWeight: 400,
    fontSize: 12,
    textAlign: 'right',
  };

  const loadData = async () => {
    const response = await getMessageBalance(errorHandler);
    setBalances(response);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const getComposeLink = () => (
    <MuiLink component={Link} to="/websms/compose" sx={linkStyles}>
      Go to Compose
    </MuiLink>
  );

  const getBillingLink = () => (
    <MuiLink component={Link} to="/billing/invoices" sx={linkStyles}>
      Go to Compose
    </MuiLink>
  );

  return (
    <CardWrapper
      title={
        creditsOnly
          ? HomeFormattedMessages.creditBalance
          : HomeFormattedMessages.messageBalance
      }
      icon="credits"
    >
      {loading ? (
        <Loader />
      ) : messageOnly ? (
        <>
          <Stack
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContenr: 'center',
                alignItems: 'center',
                gap: { xs: 1, sm: 0 },
                marginBottom: 2,
                flexDirection: { sm: 'column' },
              }}
            >
              <Typography fontSize={{ xs: 22, sm: 32, md: 56 }}>
                {balances.messagesTotal}
              </Typography>
              <Typography fontSize={{ xs: 12, sm: 15 }}>
                {HomeFormattedMessages.messageRemaining}
              </Typography>
            </Box>
          </Stack>

          {getComposeLink()}
        </>
      ) : creditsOnly ? (
        <>
          <Stack
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContenr: 'center',
                alignItems: 'center',
                gap: { xs: 1, sm: 0 },
                marginBottom: 2,
                flexDirection: { sm: 'column' },
              }}
            >
              <Typography fontSize={{ xs: 22, sm: 32, md: 56 }}>
                {balances.creditsTotal}
              </Typography>
              <Typography fontSize={{ xs: 12, sm: 15 }}>
                {HomeFormattedMessages.creditsRemaining}
              </Typography>
            </Box>
          </Stack>

          {getBillingLink()}
        </>
      ) : (
        <>
          <Stack sx={{ justifyContent: 'space-between' }}>
            <Box textAlign="center">
              <Typography fontSize={26}>{balances.creditsTotal}</Typography>
              <Typography>{HomeFormattedMessages.creditsRemaining}</Typography>
            </Box>

            <Divider sx={{ marginY: 1 }} />

            <Box textAlign="center">
              <Typography fontSize={26}>{balances.messagesTotal}</Typography>
              <Typography gutterBottom>
                {HomeFormattedMessages.messageRemaining}
              </Typography>
            </Box>
          </Stack>

          {getComposeLink()}
        </>
      )}
    </CardWrapper>
  );
}
